var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c("gg-card-header", [_vm._v("Service Add-ons")]),
      _c(
        "gg-card-text",
        [
          _vm.addons.length
            ? _c("v-data-table", {
                attrs: {
                  headers: _vm.headers,
                  items: _vm.addons
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "item.name",
                      fn: function fn(_ref) {
                        var item = _ref.item
                        return [
                          _c("div", [
                            _vm._v(" " + _vm._s(item.name)),
                            _c("br"),
                            _c(
                              "small",
                              {
                                staticClass: "text--secondary"
                              },
                              [_vm._v(_vm._s(item.domain))]
                            )
                          ])
                        ]
                      }
                    },
                    {
                      key: "item.renewalcost",
                      fn: function fn(_ref2) {
                        var item = _ref2.item
                        return [_vm._v(" $" + _vm._s(item.renewalcost) + " ")]
                      }
                    },
                    {
                      key: "item.renewaldate",
                      fn: function fn(_ref3) {
                        var item = _ref3.item
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.formatRenewalDate(
                                  _vm.parseRenewalDate(item.renewaldate)
                                )
                              ) +
                              " "
                          )
                        ]
                      }
                    },
                    {
                      key: "item.status",
                      fn: function fn(_ref4) {
                        var item = _ref4.item
                        return [
                          _c(
                            "v-icon",
                            {
                              staticClass: "pb-1",
                              attrs: {
                                color: _vm.statusColor(item.status)
                              }
                            },
                            [_vm._v("mdi-circle")]
                          ),
                          _vm._v(" " + _vm._s(item.status) + " ")
                        ]
                      }
                    },
                    {
                      key: "item.actions",
                      fn: function fn(_ref5) {
                        var item = _ref5.item
                        return [
                          _c(
                            "gg-btn",
                            {
                              on: {
                                click: function click($event) {
                                  return _vm.goToCancellation(
                                    item.id,
                                    item.cancellation_id
                                  )
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  item.cancellation_pending
                                    ? "View Cancellation"
                                    : "Stop Renewal"
                                )
                              )
                            ]
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  2083413720
                )
              })
            : _c(
                "v-alert",
                {
                  staticClass: "ma-0",
                  attrs: {
                    type: "info"
                  }
                },
                [_vm._v(" No Addons purchased. ")]
              )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }